import React, { useCallback } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import { Hidden } from "@material-ui/core";
import {
  HvGlobalActions,
  HvTypography,
  HvInput,
  HvTextArea,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";

const Details: React.FC = () => {
  const { t } = useTranslation("workflowAddEdit");
  const classes = useStyles();

  const {
    values,
    setFieldTouched,
    setFieldValue,
    status,
    setStatus,
    errors,
    touched,
  } = useFormikContext<WorkflowFormData>();

  const { serverSideErrors = {} } = status;

  const parseStatus = (field: keyof WorkflowFormData) =>
    serverSideErrors[field] || (errors[field] && touched[field])
      ? "invalid"
      : "valid";

  const parseStatusMessage = (field: keyof WorkflowFormData) => {
    if (serverSideErrors[field]) {
      return serverSideErrors[field];
    }

    return errors[field] && touched[field] ? errors[field] : "";
  };

  const setValueOnForm = useCallback(
    (property: string, selection: string | number | undefined) => {
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldValue, setStatus]
  );

  return (
    <HvGrid container className={classes.root}>
      <HvGrid sm={12} item>
        <HvGlobalActions title={t("details.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("details.description")}
        </HvTypography>
      </HvGrid>
      <HvGrid className={classes.fields} container item xs={12} lg={9}>
        <HvGrid xs={12} md={6} item>
          <HvInput
            className={classes.input}
            name="name"
            label={t("details.fields.name")}
            placeholder={t("details.fields.namePlaceholder")}
            inputProps={{
              autoComplete: "off",
            }}
            required
            value={values.name}
            status={parseStatus("name")}
            statusMessage={parseStatusMessage("name")}
            onBlur={() => setFieldTouched("name")}
            onChange={(evt, value) => {
              setValueOnForm("name", value);
            }}
          />
        </HvGrid>
        <Hidden smDown>
          <HvGrid item md={6} role="presentation" />
        </Hidden>
        <HvGrid item xs={12}>
          <HvTextArea
            className={classes.textarea}
            classes={{
              input: classes.textAreaInput,
            }}
            name="description"
            label={t("details.fields.description")}
            placeholder={t("details.fields.descriptionPlaceholder")}
            rows={5}
            value={values.description}
            status={parseStatus("description")}
            statusMessage={parseStatusMessage("description")}
            onChange={(evt, value) => {
              setValueOnForm("description", value);
            }}
          />
        </HvGrid>
      </HvGrid>
    </HvGrid>
  );
};

export default Details;
